export const url = (process.env.NODE_ENV === 'development')?import.meta.env.VITE_APP_URLAPI + "api/api.php": "/api/api.php";
export const ws_base = import.meta.env.VITE_WS;